import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

/**
 * What an RO Intake page (Log ROs, Dashboard, Ready Queue) shows for a dealer without RO
 * Intake. The nav does not offer these pages for such a dealer (2026-09-24: the new views
 * are for RO Intake dealers only), but an address can still be typed or shared, so this
 * says why rather than bouncing.
 */
const RoIntakeNotEnabled = ({ dealerId, what }) => (
  <div className="mx-auto mt-12 flex max-w-md flex-col items-center space-y-3 text-center">
    <h2 className="text-charcoal-900 text-lg font-semibold">
      RO Intake is not turned on for this dealer
    </h2>
    <p className="text-charcoal-500 text-sm">{what}</p>
    <Link
      className="text-xs font-bold uppercase tracking-widest text-blue-800 hover:text-blue-900"
      to={`/dealer/${dealerId}/detail`}
    >
      Go to the Outstanding List
    </Link>
  </div>
)

RoIntakeNotEnabled.propTypes = {
  dealerId: PropTypes.string.isRequired,
  // One sentence on what the page would have shown.
  what: PropTypes.string.isRequired,
}

export default RoIntakeNotEnabled
